import { useProfileRestriction } from '@/components/ProfileRestriction/useProfileRestriction';
import { useHasFamilySubscription } from '@/hooks/useHasFamilySubscription';

export const useShowSubscriptionOffer = (): boolean => {
  const hasSubscription = useHasFamilySubscription();
  const { isRestricted } = useProfileRestriction();

  return !hasSubscription && !isRestricted;
};
